import { z } from "zod";
import { ShortText, LongText } from "./common.js";
/**
 * Text card — Hoshin canvas Yjs-native (PB-234). A free-form note with a
 * title and a plain-text body. Plain text only (React escapes text children);
 * no HTML/markdown/sanitiser. Content lives inline in the canvas Y.Doc.
 */
export const TextCardParamsSchema = z
    .object({
    title: ShortText,
    body: LongText,
})
    .strict();
export const defaultTextCardParams = {
    title: "",
    body: "",
};
//# sourceMappingURL=textCard.js.map